import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { verifyMagicLink } from "../api";

export default function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setErrorMessage("Missing sign-in token. Please use the link from your email.");
      return;
    }
    verifyMagicLink(token)
      .then(() => navigate("/dashboard", { replace: true }))
      .catch((err) => {
        setStatus("error");
        setErrorMessage(err.message || "This link is invalid or has expired.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page">
      <div className="card">
        <h1>Signing you in…</h1>
        {status === "loading" && <p className="muted">One moment while we verify your link.</p>}
        {status === "error" && (
          <>
            <div className="alert alert-error">{errorMessage}</div>
            <p className="muted" style={{ marginTop: 16 }}>
              <Link className="btn-link" to="/">Request a new sign-in link</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
